import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Cascader,
  Typography,
  Col,
  Row,
  Tooltip,
  Collapse,
  Menu,
  Dropdown,
} from 'antd';
import Icon, { InfoCircleFilled, MoreOutlined } from '@ant-design/icons';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { allowedSubdomainLookup } from '../../../../shared-components/Validation/Subdomain';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import { ReactComponent as no_results_filled } from '../../../../assets/icons/no_results_filled.svg';
import cx from 'classnames';
import _ from 'lodash';
import SubdomainFinderResult from '../SubdomainFinderExploreRecipe/ResultsTable';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';
import DeleteRecipeModal from '../../../../shared-components/DeleteRecipeModal';
import { JSONViewer } from '../../../../shared-components/JSONViewer';
import { BackToTopButton } from '../../../../shared-components/BackToTopButton';
import {
  exportSubdomainFinderToCSV,
  exportSubdomainFinderToJSON,
} from '../../../../redux/actions/ioc';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

const { Panel } = Collapse;

function SubdomainFinderQuery(props) {
  mixpanel.track('Global Nav - Subdomain Finder', {
    location: window.location.href,
  });
  const {
    exploreRecipeSubdomainFinder,

    exploreRecipeSpoofing,
    loadMergeAPIRiskScores,
    loadMergeAPIASNDetails,
    loadUser,
    loadSources,
    createEmptySource,
    createFileSource,
    updateFileSource,
    addIOCJson,
    clearExploreDetails,
    loadScoreDetails,
    loadMergeAPIExploreRecipe,
    loadMergeAPIEnrichment,
    loadMergeAPIIPDetails,
    loadMergeAPIDomainDetails,
    loadMergeAPIExploreDetails,
    loadMergeAPIMergeDetails,
    loadMergeAPIExploreAnyIPDetails,
    loadMergeAPIExploreDensity,
    loadMergeAPIWhoisDetails,
    loadMergeAPIDomainInfraTags,
    loadIPEditableFeeds,
    loadDomainEditableFeeds,
    loadURLEditableFeeds,
    searchForTags,
    resetTagSearch,
    saveMonitoringQuery,
    loadResultFile,
    loadHistoryQueryResult,
    exportExploreResultToCSV,
    exportExploreResultToJSON,
    exportSubdomainFinderToCSV,
    exportSubdomainFinderToJSON,
    exportSingleIOC,
    resetEnrichment,
    loadMySubscriptionPlan,
    saveBreadCrumbs,
    queryNameInTXTRecipe,

    user,
    sources,
    exploreFilters,
    exploreSorting,
    status,
    scoreDetails,
    mergeAPIEnrichment,
    mergeAPIscoreDetails,
    exploreAPIscoreDetails: exploreAPIscoreDetails,
    mergeAPIData: mergeAPIData,
    exploreAPIANYIPscoreDetails: exploreAPIANYIPscoreDetails,
    exploreAPIANYIPJobID: exploreAPIANYIPJobID,
    exploreAPIDensityDetails: exploreAPIDensityDetails,
    exploreAPIDensityStatus: exploreAPIDensityStatus,
    exploreAPIwhoisDetails: exploreAPIwhoisDetails,
    infraTagStatus: infraTagStatus,
    domainInfraTags: domainInfraTags,
    whoisStatus: whoisStatus,
    IPEditableFeeds: IPEditableFeeds,
    IPEditableFeedsStatus: IPEditableFeedsStatus,
    DomainEditableFeeds: DomainEditableFeeds,
    DomainEditableFeedsStatus: DomainEditableFeedsStatus,
    URLEditableFeeds: URLEditableFeeds,
    URLEditableFeedsStatus: URLEditableFeedsStatus,
    foundTags: foundTags,
    searchStatus: searchStatus,
    riskScoreStatus: riskScoreStatus,
    exploreRiskScores: exploreRiskScores,
    exploreASNStatus: exploreASNStatus,
    exploreASNDetails: exploreASNDetails,
    mySubscriptionPlan: mySubscriptionPlan,
    mySubscriptionPlanStatus: mySubscriptionPlanStatus,
    breadcrumbs: breadcrumbs,
    loadBrandImpersonationRecipeResults,
    loadSubdomainFinderRecipeResults,
    clearRecipe,
    unsetClearRecipe,
    deleteMergeAPIExploreRecipeDanglingDNSProtection,
  } = props;

  const PrettyPrintJson = React.memo(({ data }) => (
    <div style={{ textAlign: 'left' }}>
      <JSONViewer data={data} />
    </div>
  ));

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  const q = useQuery();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const threatNameValue = Form.useWatch('threat_name', form);
  const sortFormValue = Form.useWatch('sort', form);
  const { Text, Paragraph, Title } = Typography;

  const [searchQuery, setSearchQuery] = useState('');
  const ClearFilters = (props) => <Icon component={no_results} {...props} />;
  const ClearFiltersFilled = (props) => (
    <Icon component={no_results_filled} {...props} />
  );
  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

  const [activeCollapseKey, setActiveCollapseKey] = useState(['1']);

  const openAllCollapse = () => {
    setActiveCollapseKey(['1', '2']);
  };

  const toggleCollapse = (key) => {
    if (activeCollapseKey?.includes(key)) {
      setActiveCollapseKey(activeCollapseKey?.filter((k) => k !== key));
    } else {
      setActiveCollapseKey([...activeCollapseKey, key]);
    }
  };

  const recipeInitCollapse = () => {
    setActiveCollapseKey(['1']);
  };

  const searchActionCollapse = () => {
    setActiveCollapseKey(['2']);
  };

  const options = [
    {
      value: 'first_seen',
      label: 'First Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'last_seen',
      label: 'Last Seen',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'query',
      label: 'Query',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
    {
      value: 'answer',
      label: 'Answer',
      children: [
        {
          value: 'asc',
          label: 'Ascending',
        },
        {
          value: 'desc',
          label: 'Descending',
        },
      ],
    },
  ];

  const titleText = 'Subdomains';

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.clearExploreDetails();
    form.resetFields();
    recipeInitCollapse();
    setSearchQuery('');

    if (q?.get('recipeid')) {
      //load specific recipe
      props.loadMergeAPIExploreRecipeSubdomainFinder(q?.get('recipeid'));
    }
    dispatch(changeTitle(titleText, null));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.resetRecipeStatus();
    form.resetFields();
    recipeInitCollapse();
    setSaveModalType('saveNew');
    setSearchQuery('');

    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeSubdomainFinder(q?.get('recipeid'));
    }
  }, [window.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (clearRecipe === true) {
      document.title = `${titleText} - Silent Push`;
      props.clearExploreDetails();
      props.saveBreadCrumbs(null);
      props.loadUser();
      props.loadMySubscriptionPlan();
      props.resetRecipeStatus();
      props.clearExploreDetails();
      form.resetFields();
      recipeInitCollapse();
      setSearchQuery('');
      props.unsetClearRecipe();
    }
  }, [clearRecipe]); // eslint-disable-line react-hooks/exhaustive-deps

  function resetForm() {
    form.resetFields();
    props.resetRecipeStatus();
    recipeInitCollapse();
    props.clearExploreDetails();
    props.saveBreadCrumbs(null);
    setSearchQuery('');
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeSubdomainFinder(q?.get('recipeid'));
    }
  }

  useEffect(() => {
    form.resetFields();
    dispatch(
      changeTitle(props?.exploreRecipeSubdomainFinder?.name ?? titleText, null),
    );
    document.title = `${titleText} - Silent Push`;
    if (
      props.recipeStatusSubdomainFinder == STATUS.LOADED &&
      props?.exploreRecipeSubdomainFinder?.name
    ) {
      document.title = `${props?.exploreRecipeSubdomainFinder?.name} - Silent Push`;
    }

    if (window.location.href.includes('/explore/subdomain-finder')) {
      if (
        props?.exploreRecipeSubdomainFinder?.uuid &&
        window.location.href.indexOf(
          '/explore/subdomain-finder?recipeid=' +
            props?.exploreRecipeSubdomainFinder?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/subdomain-finder?recipeid=' +
            props?.exploreRecipeSubdomainFinder?.uuid,
        );
        dispatch(highlightLeftMenu(props?.exploreRecipeSubdomainFinder?.uuid));
      }
      form.resetFields();
      form.setFieldsValue({
        threat_name: exploreRecipeSubdomainFinder?.domain,
        type: exploreRecipeSubdomainFinder?.query_type,
        window: exploreRecipeSubdomainFinder?.window,
        limit:
          exploreRecipeSubdomainFinder?.limit === 100
            ? ''
            : exploreRecipeSubdomainFinder?.limit,
        sort: exploreRecipeSubdomainFinder?.sort_by
          ? [
              exploreRecipeSubdomainFinder?.sort_by,
              exploreRecipeSubdomainFinder?.order_by,
            ]
          : null,
      });
    }
  }, [props.exploreRecipeSubdomainFinder]);

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function FormHeader() {
    return (
      <div onClick={() => toggleCollapse('1')}>
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
        >
          Query Form
        </Title>
      </div>
    );
  }

  function ResultsHeader() {
    return (
      <div onClick={() => toggleCollapse('2')}>
        <Title
          level={4}
          style={{
            textAlign: 'left',
            color: 'white',
            lineHeight: '2',
            margin: '0',
          }}
        >
          Query Results
        </Title>
      </div>
    );
  }

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeSubdomainFinder({
      scope:
        props?.exploreRecipeSubdomainFinder?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props?.exploreRecipeSubdomainFinder?.uuid,
    });
    incrementUIRequestsCounter();
  }

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeSubdomainFinder?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeSubdomainFinder?.description,
      };
    } else {
      return {
        name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeSubdomainFinder?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeSubdomainFinder?.description,
        domain: values?.threat_name,
        query_type: values?.type ? values?.type : 'A',
        window: values?.window ? values.window : '14',
        limit: values?.limit ? values?.limit : 100,
        order_by: values?.sort?.length > 0 ? values?.sort[1] : null,
        sort_by: values?.sort?.length > 0 ? values?.sort[0] : null,
        uuid: q?.get('recipeid'),
      };
    }
  }

  function updateButtonDisabled() {
    const period = form.getFieldValue('window');

    if (
      exploreRecipeSubdomainFinder?.domain !== threatNameValue ||
      exploreRecipeSubdomainFinder?.window !== period ||
      exploreRecipeSubdomainFinder?.sort_by != sortFormValue?.[0] ||
      exploreRecipeSubdomainFinder?.order_by != sortFormValue?.[1]
    ) {
      return false;
    } else {
      if (threatNameValue === undefined) {
        return false;
      }
      return true;
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeSubdomainFinder(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeSubdomainFinder(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'subdomain-finder-recipes',
            q?.get('recipeid'),
          );
        }
        incrementUIRequestsCounter();
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  const handleDeleteRecipe = () => {
    props.deleteMergeAPIExploreRecipeSubdomainFinder(q?.get('recipeid'));
    props.resetRecipeStatus();
    props.clearExploreDetails();
    props.history.push('/explore/subdomain-finder/?left_menu_name=Subdomains');
    setIsDeleteModalVisible(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  const DropdownMenu = () => {
    return (
      <Menu>
        {
          <>
            {((q?.get('recipeid') &&
              props?.exploreRecipeSubdomainFinder?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeSubdomainFinder?.scope === 'ORGANISATION' &&
                props?.exploreRecipeSubdomainFinder?.is_mine === true)) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('edit');
                  setIsModalVisible(true);
                }}
              >
                Edit Metadata
              </Menu.Item>
            )}

            {((q?.get('recipeid') &&
              props?.exploreRecipeSubdomainFinder?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeSubdomainFinder?.scope ===
                  'ORGANISATION')) && (
              <Menu.Item
                onClick={() => {
                  setSaveModalType('saveAs');
                  setIsModalVisible(true);
                }}
              >
                Save As
              </Menu.Item>
            )}

            <Tooltip
              title={
                props.mySubscriptionPlan?.has_access_to_share_unshare ? (
                  ''
                ) : (
                  <>
                    Sharing option is not part of this subscription plan. To
                    upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                )
              }
            >
              {((q?.get('recipeid') &&
                props?.exploreRecipeSubdomainFinder?.scope === 'USER') ||
                (q?.get('recipeid') &&
                  props?.exploreRecipeSubdomainFinder?.scope ===
                    'ORGANISATION' &&
                  props?.exploreRecipeSubdomainFinder?.is_mine === true)) && (
                <Menu.Item onClick={() => changeScopeRecipe()}>
                  {props?.exploreRecipeSubdomainFinder?.scope === 'ORGANISATION'
                    ? 'Unshare'
                    : 'Share'}
                </Menu.Item>
              )}
            </Tooltip>

            {((q?.get('recipeid') &&
              props?.exploreRecipeSubdomainFinder?.scope === 'USER') ||
              (q?.get('recipeid') &&
                props?.exploreRecipeSubdomainFinder?.scope === 'ORGANISATION' &&
                props?.exploreRecipeSubdomainFinder?.is_mine === true)) && (
              <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
                <span style={{ color: 'red' }}>Delete</span>
              </Menu.Item>
            )}
          </>
        }
      </Menu>
    );
  };

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan?.has_access_to_subdomain_finder_recipe ? (
        props.recipeStatusSubdomainFinder !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div
                  data-cy="subdomainFinderRecipeQueryFormChip"
                  className={threat_detail_styles['type-chip']}
                >
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph
                    data-cy="subdomainFinderRecipeQueryFormDescription"
                    className="m-0"
                  >
                    {exploreRecipeSubdomainFinder?.description
                      ? exploreRecipeSubdomainFinder.description
                      : 'Subdomain Finder will show you the subdomains associated with a domain.'}{' '}
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/obtain-a-list-of-subdomains-1',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  <Tooltip
                    title={
                      updateButtonDisabled() ? 'Form values unchanged.' : ''
                    }
                  >
                    <Button
                      disabled={updateButtonDisabled()}
                      role={'button1'}
                      onClick={() => {
                        if (
                          saveModalType === 'saveNew' &&
                          !q?.get('recipeid')
                        ) {
                          form
                            .validateFields()
                            .then((values) => {
                              setNameOfNewQuery('');
                              setDescriptionOfNewQuery('');
                              setSaveModalType('saveNew');
                              setIsModalVisible(true);
                            })
                            .catch((errorInfo) => {});
                        } else {
                          handleOk('edit');
                        }
                      }}
                    >
                      {q?.get('recipeid') ? 'Update' : 'Save'}
                    </Button>
                  </Tooltip>

                  {((q?.get('recipeid') &&
                    props?.exploreRecipeSubdomainFinder?.scope === 'USER') ||
                    (q?.get('recipeid') &&
                      props?.exploreRecipeSubdomainFinder?.scope ===
                        'ORGANISATION')) && (
                    <Dropdown trigger={['click']} overlay={DropdownMenu({})}>
                      <MoreOutlined className={styles.dropdown_icon} />
                    </Dropdown>
                  )}
                </div>
              </Col>
            </Row>

            <BackToTopButton />

            <div className={cx('collapse_row_recipe')}>
              <Collapse
                defaultActiveKey={['1']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={FormHeader()} key="1">
                  <Form
                    className={styles.form}
                    form={form}
                    name="explore"
                    initialValues={{
                      threat_name: exploreRecipeSubdomainFinder?.domain,
                      type: exploreRecipeSubdomainFinder?.query_type,
                      window: exploreRecipeSubdomainFinder?.window,
                      limit:
                        exploreRecipeSubdomainFinder?.limit === 100
                          ? ''
                          : exploreRecipeSubdomainFinder?.limit,
                      sort: exploreRecipeSubdomainFinder?.sort_by
                        ? [
                            exploreRecipeSubdomainFinder?.sort_by,
                            exploreRecipeSubdomainFinder?.order_by,
                          ]
                        : null,
                    }}
                    onFinish={(values) => {
                      props.saveBreadCrumbs(null);
                      // props.history.push(
                      setSearchQuery(
                        `/explore-result?name=*.${values.threat_name
                          .replace('[', '')
                          .replace(']', '')
                          .replace(' ', '')
                          .trim()}&queryType=query&type=` +
                          (values.type ? values.type : 'A') +
                          `&last_seen_after=-1209600` +
                          (values.limit ? `&limit=${values.limit}` : '') +
                          (values?.sort?.length > 0
                            ? `&sort_by=${values?.sort[0]}&order_by=${values?.sort[1]}`
                            : '') +
                          '&origin_uid=SUBDOMAINS&recipe=/explore/subdomain-finder' +
                          ((q?.get('recipeid')
                            ? `?recipeid=${q?.get('recipeid')}`
                            : '') ?? '') +
                          '&backLink=' +
                          encodeURIComponent(window.location.pathname) +
                          encodeURIComponent(window.location.search),
                      );
                      searchActionCollapse();
                      setTimeout(() => {
                        window.scrollTo(0, 0);
                      }, '10');
                    }}
                  >
                    <Row gutter={36}>
                      <Col xs={24} lg={12}>
                        <Title
                          data-cy="subdomainFinderRecipeQueryFormDomainLabel"
                          level={5}
                        >
                          Domain *
                        </Title>

                        <Text data-cy="subdomainFinderRecipeQueryFormDomainNameLabel">
                          Domain Name{' '}
                          <Tooltip
                            placement="top"
                            title="Enter a domain name. Subdomains are included in the search. Wildcards are not supported."
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>
                        <Form.Item
                          name="threat_name"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(fieldObject, fieldValue) {
                                const validation = validateRecipeDomainName(
                                  fieldValue,
                                  titleText,
                                );

                                if (validation.valid) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(validation?.message);
                                }
                              },
                            }),
                          ]}
                        >
                          <Input
                            data-cy="subdomainFinderRecipeQueryFormDomainNameInput"
                            maxLength={255}
                            placeholder="Enter Domain Name"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}></Col>

                      <Col xs={24} lg={12}>
                        <Title
                          data-cy="subdomainFinderRecipeRecordLastSeenLabel"
                          level={5}
                        >
                          Last Seen
                        </Title>

                        <Text data-cy="subdomainFinderRecipeRecordPeriodLabel">
                          Period{' '}
                          <Tooltip
                            placement="top"
                            title="Only show records last observed in the selected period. (optional)"
                          >
                            <InfoCircleFilled />
                          </Tooltip>
                        </Text>
                        <Form.Item
                          name="window"
                          rules={[
                            {
                              required: false,
                              message: 'Please input the window!',
                            },
                          ]}
                        >
                          <Select
                            data-cy="subdomainFinderRecipeRecordPeriodSelect"
                            options={[{ label: '14 days', value: '14' }]}
                            defaultValue="14"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12}>
                        <Title
                          data-cy="subdomainFinderRecipeQueryFormSortingLabel"
                          level={5}
                        >
                          Sorting
                        </Title>

                        <Text data-cy="subdomainFinderRecipeQueryFormSortingSelectLabel">
                          Sort/Order
                        </Text>
                        <Form.Item name="sort">
                          <Cascader
                            data-cy="subdomainFinderRecipeQueryFormSortingSelect"
                            options={options}
                            placeholder="Sort/Order"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <div className={styles.bottom_actions}>
                      <Form.Item>
                        <Tooltip
                          title={
                            props.mySubscriptionPlan?.has_access_to_explore ? (
                              ''
                            ) : (
                              <>
                                This option is not part of this subscription
                                plan. To upgrade your subscription contact us at{' '}
                                <a
                                  target="_blank"
                                  href="mailto:sales@silentpush.com"
                                >
                                  sales@silentpush.com
                                </a>
                                .
                              </>
                            )
                          }
                        >
                          <Button
                            disabled={
                              !props.mySubscriptionPlan?.has_access_to_explore
                            }
                            role={'button2'}
                            type="primary"
                            htmlType="submit"
                          >
                            Search
                          </Button>
                        </Tooltip>
                      </Form.Item>

                      <Button
                        className="ms-05"
                        type="link"
                        onClick={() => resetForm()}
                      >
                        Reset
                      </Button>
                    </div>
                  </Form>
                </Panel>
              </Collapse>
            </div>

            <div className={cx('collapse_row_recipe')}>
              <Collapse
                defaultActiveKey={['2']}
                activeKey={activeCollapseKey}
                expandIconPosition={'end'}
              >
                <Panel header={ResultsHeader()} key="2">
                  <div>
                    {searchQuery ? (
                      <SubdomainFinderResult
                        searchQuery={searchQuery}
                        mySubscriptionPlanStatus={
                          props.mySubscriptionPlanStatus
                        }
                        mySubscriptionPlan={props.mySubscriptionPlan}
                        loadMergeAPIRiskScores={loadMergeAPIRiskScores}
                        loadMergeAPIASNDetails={loadMergeAPIASNDetails}
                        loadUser={loadUser}
                        loadSources={loadSources}
                        createEmptySource={createEmptySource}
                        createFileSource={createFileSource}
                        updateFileSource={updateFileSource}
                        addIOCJson={addIOCJson}
                        clearExploreDetails={clearExploreDetails}
                        loadScoreDetails={loadScoreDetails}
                        loadMergeAPIExploreRecipe={loadMergeAPIExploreRecipe}
                        loadMergeAPIEnrichment={loadMergeAPIEnrichment}
                        loadMergeAPIIPDetails={loadMergeAPIIPDetails}
                        loadMergeAPIDomainDetails={loadMergeAPIDomainDetails}
                        loadMergeAPIExploreDetails={loadMergeAPIExploreDetails}
                        loadMergeAPIMergeDetails={loadMergeAPIMergeDetails}
                        loadMergeAPIExploreAnyIPDetails={
                          loadMergeAPIExploreAnyIPDetails
                        }
                        loadMergeAPIExploreDensity={loadMergeAPIExploreDensity}
                        loadMergeAPIWhoisDetails={loadMergeAPIWhoisDetails}
                        loadMergeAPIDomainInfraTags={
                          loadMergeAPIDomainInfraTags
                        }
                        loadIPEditableFeeds={loadIPEditableFeeds}
                        loadDomainEditableFeeds={loadDomainEditableFeeds}
                        loadURLEditableFeeds={loadURLEditableFeeds}
                        searchForTags={searchForTags}
                        resetTagSearch={resetTagSearch}
                        saveMonitoringQuery={saveMonitoringQuery}
                        loadResultFile={loadResultFile}
                        loadHistoryQueryResult={loadHistoryQueryResult}
                        exportExploreResultToCSV={exportExploreResultToCSV}
                        exportExploreResultToJSON={exportExploreResultToJSON}
                        exportSubdomainFinderToCSV={exportSubdomainFinderToCSV}
                        exportSubdomainFinderToJSON={
                          exportSubdomainFinderToJSON
                        }
                        exportSingleIOC={exportSingleIOC}
                        resetEnrichment={resetEnrichment}
                        loadMySubscriptionPlan={loadMySubscriptionPlan}
                        saveBreadCrumbs={saveBreadCrumbs}
                        queryNameInTXTRecipe={queryNameInTXTRecipe}
                        user={user}
                        //sources
                        exploreFilters={exploreFilters}
                        exploreSorting={exploreSorting}
                        status={status}
                        scoreDetails={scoreDetails}
                        mergeAPIEnrichment={mergeAPIEnrichment}
                        mergeAPIscoreDetails={mergeAPIscoreDetails}
                        exploreAPIscoreDetails={exploreAPIscoreDetails}
                        mergeAPIData={mergeAPIData}
                        exploreAPIANYIPscoreDetails={
                          exploreAPIANYIPscoreDetails
                        }
                        exploreAPIANYIPJobID={exploreAPIANYIPJobID}
                        exploreAPIDensityDetails={exploreAPIDensityDetails}
                        exploreAPIDensityStatus={exploreAPIDensityStatus}
                        exploreAPIwhoisDetails={exploreAPIwhoisDetails}
                        infraTagStatus={infraTagStatus}
                        domainInfraTags={domainInfraTags}
                        whoisStatus={whoisStatus}
                        IPEditableFeeds={IPEditableFeeds}
                        IPEditableFeedsStatus={IPEditableFeedsStatus}
                        DomainEditableFeeds={DomainEditableFeeds}
                        DomainEditableFeedsStatus={DomainEditableFeedsStatus}
                        URLEditableFeeds={URLEditableFeeds}
                        URLEditableFeedsStatus={URLEditableFeedsStatus}
                        foundTags={foundTags}
                        searchStatus={searchStatus}
                        riskScoreStatus={riskScoreStatus}
                        exploreRiskScores={exploreRiskScores}
                        exploreASNStatus={exploreASNStatus}
                        exploreASNDetails={exploreASNDetails}
                        breadcrumbs={breadcrumbs}
                        loadBrandImpersonationRecipeResults={
                          loadBrandImpersonationRecipeResults
                        }
                        loadSubdomainFinderRecipeResults={
                          loadSubdomainFinderRecipeResults
                        }
                        websocketConnection={props?.websocketConnection}
                      />
                    ) : (
                      <div className={styles.empty_state}>
                        <NoDataIcon
                          style={{ fontSize: 32, marginTop: '8px' }}
                        />
                        <Title level={4}>Query didn't run</Title>

                        <Text>
                          For the results you need to fill out the query form
                          and click Search.
                        </Text>
                      </div>
                    )}
                  </div>
                </Panel>
              </Collapse>
            </div>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={exploreRecipeSubdomainFinder}
      />
      <DeleteRecipeModal
        isDeleteModalVisible={isDeleteModalVisible}
        handleOk={handleDeleteRecipe}
        handleCancel={handleDeleteCancel}
        loadedRecipe={exploreRecipeSubdomainFinder}
      />
      {renderPane()}
      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid') ? props.recipeStatusSubdomainFinder : STATUS.LOADED
        }
      />
    </>
  );
}

export default SubdomainFinderQuery;
